export function addInitAnsweredConversation(conversations) {
  return {
    type: '@ANSWERED_CONVERSATION/ADD_INIT_CONVERSATIONS',
    payload: {
      conversations
    }
  };
}

export function addAnsweredConversation(conversation) {
  return {
    type: '@ANSWERED_CONVERSATION/ADD_CONVERSATION',
    payload: {
      conversation
    }
  };
}
/**
 * @description Atualiza statusOfChat da conversa para alterar a cor da tag de alerta do cliente e do agente
 * @param {
 *  chatId: string,
 *  statusOfChat: string
 * }
 */
export function addStatusMetricsOfConversation({ chatId, statusOfChat }) {
  return {
    type: '@ANSWERED_CONVERSATION/CHANGE_STATUS_METRICS_OF_CONVERSATION',
    payload: {
      chatId,
      statusOfChat
    }
  };
}

export function addMessageAnsweredConversation(
  message,
  idDaConversa,
  novas_mensagens
) {
  return {
    type: '@ANSWERED_CONVERSATION/ADD_MESSAGE_ANSWERED_CONVERSATION',
    payload: {
      message,
      idDaConversa,
      novas_mensagens
    }
  };
}

export function removeAnsweredConversation(id) {
  return {
    type: '@ANSWERED_CONVERSATION/REMOVE_CONVERSATION',
    payload: {
      id
    }
  };
}

export function addTagsAnsweredConversationInAttendance(data) {
  const { contactId, newContactTag } = data.data;

  return {
    type: '@ANSWERED_CONVERSATION/UPDATE_TAGS_ANSWERED_CONVERSATION',
    payload: {
      contactId,
      newContactTag
    }
  };
}

/**
 *
 * @param {{
 *  contactId: NumberConstructor,
 *  newContactName: string
 * }} data
 * @returns
 */
export function alterContactNameOnConversation(data) {
  return {
    type: '@ANSWERED_CONVERSATION/ALTER_CONTACT_NAME',
    payload: {
      data
    }
  };
}
